<div class="kendo-formfield">
  <kendo-label text="Email"></kendo-label>
  <div class="email-filter-container">
    <kendo-dropdownlist [data]="emailFilterOperators" textField="text" valueField="value" [valuePrimitive]="true"
      [value]="operator" (valueChange)="onOperatorChange($event)" fillMode="outline">
    </kendo-dropdownlist>
    <kendo-textbox [value]="text" (valueChange)="onTextChange($event)" (keydown.enter)="enterPressed.emit()"
      [placeholder]="isEmailInputDisabled ? '' : 'Email ' + selectedOperatorText" fillMode="outline"
      [clearButton]="false" [disabled]="isEmailInputDisabled" style="width: 100%;">
    </kendo-textbox>
  </div>
</div>
